import { InputNumber } from "primereact/inputnumber";
import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Include styles

export interface FreeTextConfig {
  content: string;
  height?: number;
}

interface FreeTextEditorProps {
  config: FreeTextConfig;
  onConfigChange: (config: FreeTextConfig) => void;
}

const FreeTextEditor = ({ config, onConfigChange }: FreeTextEditorProps) => {
  const [value, setValue] = useState(config?.content ?? "");

  const handleChange = (content: string) => {
    setValue(content);
    onConfigChange({ content });
  };

  return (
    <div className="flex flex-column gap-3">
      <div className="flex flex-column gap-2 w-2">
        <label htmlFor="height">Height (px)</label>
        <InputNumber
          id="height"
          value={config.height ?? undefined}
          onChange={e => onConfigChange({ ...config, height: e.value ?? undefined })}
        />
      </div>
      <ReactQuill
        value={value}
        onChange={handleChange}
        modules={{
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            [{ font: [] }],
            [{ align: [] }],
            ["clean"],
          ],
        }}
      />
      <h4 className="border-bottom-1 pb-2 mb-2">Preview</h4>
      <div className="quill-rendered-content bg-white">
        <div dangerouslySetInnerHTML={{ __html: value }} />
      </div>
    </div>
  );
};

export default FreeTextEditor;
